import { render, staticRenderFns } from "./GroupInvitationNotification.vue?vue&type=template&id=06dc6dac&"
import script from "./GroupInvitationNotification.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports